import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/components/PageHeader";
import { ListingCard } from "@/components/ListingCard";
import { useT } from "@/context/LanguageContext";

export default function Collection() {
  const t = useT();
  const [listings, setListings] = useState([]);
  useEffect(() => { api.get("/listings").then((r) => setListings(r.data)).catch(() => {}); }, []);
  return (
    <>
      <Seo title="La Collection — Locations saisonnières d’exception" description="Découvrez la Collection Riviera Host Collection : des adresses singulières à Cannes, Le Cannet et en France." path="/collection" />
      <PageHeader overline={t.collection.overline} title={t.collection.title} intro={t.collection.intro} />
      <section className="py-20 sm:py-28 max-w-[1500px] mx-auto px-5 sm:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-16">
          {listings.map((l, i) => (<Reveal key={l.slug} delay={(i % 3) * 0.08}><ListingCard listing={l} index={i} /></Reveal>))}
        </div>
        {listings.length === 0 && <p className="text-ink/50">{t.collection.empty}</p>}
      </section>
    </>
  );
}
